var root = require('./_root');

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;



//////////////////
// WEBPACK FOOTER
// /Users/leedongwei/Documents/Projects/crimp-application/node_modules/antd/node_modules/lodash/_Symbol.js
// module id = 162
// module chunks = 0